import { ReactComponent as SupportMomentHeartGroup } from "shared/assets/Icons/heart-group.svg";
import { useState } from "react";
import { t } from "i18next";
import classNames from "classnames";
import Button from "shared/UI/Buttons/Button";
import { trackCardClicks } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import { SupportOptionsModal } from "../../../SupportMoments/Components/SupportOptionsModal/SupportOptionsModal";
import { useSupportMomentsAvailability } from "./hooks/useSupportMomentsAvailability/useSupportMomentsAvailability";

export const SupportMomentsCard = () => {
  const [isSupportOptionsModalOpen, setIsSupportOptionsModalOpen] = useState(false);
  const { isLoading, isAvailable, resources, coachmarkStatus, isLoadingCoachmarkStatus, mutateCoachmarkStatus } = useSupportMomentsAvailability();
  const isDisabled = isLoading || !isAvailable;
  const isUnavailable = !isLoading && !isAvailable;

  const handleClick = () => {
    trackCardClicks(EventNames.SUPPORT_MOMENTS_CLICK);
    setIsSupportOptionsModalOpen(true);
  };

  return (
    <div className={classNames("flex flex-col !p-0 overflow-hidden shadow-md rounded-[20px]", { "opacity-50": isDisabled })}>
      <div id="support-moments" className="py-6 pl-6 relative w-full min-h-[160px]">
        <div className="space-y-2 w-3/4">
          <h2>{t("supportMoments.card.title")}</h2>
          <p className="w-[90%]">{isUnavailable ? t("supportMoments.card.unavailableDescription") : t("supportMoments.card.description")}</p>
          <SupportMomentHeartGroup className="absolute -top-1 right-0 h-auto" />
        </div>
      </div>
      <Button
        variant="default"
        text={t("supportMoments.card.cta")}
        onClick={handleClick}
        disabled={isDisabled}
        className="!w-[90%] max-w-[400px] mx-auto mt-3 mb-8"
      />
      {isSupportOptionsModalOpen && (
        <SupportOptionsModal
          onClose={() => setIsSupportOptionsModalOpen(false)}
          resources={resources}
          coachmarkStatus={coachmarkStatus}
          isLoadingCoachmarkStatus={isLoadingCoachmarkStatus}
          mutateCoachmarkStatus={mutateCoachmarkStatus}
        />
      )}
    </div>
  );
};
